// TODO(문구): 임시안 — Figma 확정 후 교체 (#213)
import BottomSheet from "@/shared/ui/BottomSheet";
import PrimaryButton from "@/shared/ui/PrimaryButton";
import lockIcon from "@/assets/icons/common/lock.png";
import { useTapInteraction } from "@/shared/ui/pressable";
import styles from "./Credit4uOutOfSyncSheet.module.scss";

export type Credit4uOutOfSyncSheetProps = {
  isOpen: boolean;
  /** [비밀번호 재설정하기] — 세션용 재설정 화면으로 이동 */
  onReset: () => void;
  /** [닫기] — 미갱신 상태 유지 */
  onClose: () => void;
};

type SecondaryButtonProps = {
  onClick: () => void;
  children: string;
};

const SecondaryButton = ({ onClick, children }: SecondaryButtonProps) => {
  const { isPressed, ref, pressHandlers } =
    useTapInteraction<HTMLButtonElement>();
  return (
    <button
      ref={ref}
      type="button"
      className={`${styles.ctaSecondary} ${isPressed ? styles.pressed : ""}`.trim()}
      onClick={onClick}
      {...pressHandlers}
    >
      {children}
    </button>
  );
};

// 신용정보원(credit4u) OUT_OF_SYNC 재설정 유도 안내 — Figma 확정 전 (#213).
// Credit4uPasswordExpirySheet 와 동일한 floating BottomSheet 패턴
// (배경 dim Fade In + sheet 하단→상단 slide up).
// 사용자 명시 선택(버튼) 전용 sheet — 배경 탭·native back 은 흔들림(닫힘 불가, BottomSheet 공통 규칙), ESC·drag 비활성.
const Credit4uOutOfSyncSheet = ({
  isOpen,
  onReset,
  onClose,
}: Credit4uOutOfSyncSheetProps) => (
  <BottomSheet
    isOpen={isOpen}
    // 외부 닫힘 트리거(ESC 등)가 모두 비활성이라 실제로 호출되지 않는 no-op (Credit4uPasswordExpirySheet 동일).
    onClose={() => {}}
    presentation="partial"
    placementStyle="floating"
    showCloseButton={false}
    closeOnBackdrop={false}
    closeOnEsc={false}
    draggable={false}
    showDragHandle={false}
    contentClassName={styles.sheetContent}
  >
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="credit4u-out-of-sync-title"
      className={styles.sheetBody}
    >
      <img
        src={lockIcon}
        alt=""
        className={styles.icon}
        width="50"
        height="50"
      />
      <div className={styles.textGroup}>
        <h2 id="credit4u-out-of-sync-title" className={styles.title}>
          비밀번호를 다시 설정해 주세요
        </h2>
        <p className={styles.desc}>
          {
            "저장된 비밀번호가 신용정보원 정보와 달라요.\n재설정하면 바로 복구할 수 있어요."
          }
        </p>
      </div>
    </div>
    <div className={styles.actions}>
      <PrimaryButton type="button" onClick={onReset}>
        비밀번호 재설정하기
      </PrimaryButton>
      <SecondaryButton onClick={onClose}>닫기</SecondaryButton>
    </div>
  </BottomSheet>
);

export default Credit4uOutOfSyncSheet;
